import produce from "immer"
import { ProductDtoAttributes, initialProductState } from "./Product"
import { ProductStateHandler } from "./ProductStateHandler"
import {
    MATRIX_AXIS_DELETED,
    MATRIX_AXIS_TYPE,
    MATRIX_AXIS_UPDATED,
    MATRIX_ITEM_DELETED,
    MATRIX_ITEM_RESTORED,
    MATRIX_ITEM_UPDATED,
    MODIFY_BUNDLE,
    MatrixItemPayload,
    MatrixItemUpdatePayload,
    PRODUCT_CLEARED,
    PRODUCT_LOADED,
    PRODUCT_UPDATED,
    ProductUpdatePayload
} from "./Types"
import { PRODUCT_ACTION_TYPES, ProductActions } from "./actions"
import { bundleReducer } from "./bundle/reducers"
import { MatrixAxis } from "./matrix/Matrix"

type action =
    | { type: PRODUCT_LOADED, payload: ProductDtoAttributes }
    | { type: PRODUCT_CLEARED }
    | { type: PRODUCT_UPDATED, payload: ProductUpdatePayload }
    | { type: MATRIX_AXIS_UPDATED, payload: MatrixAxis }
    | { type: MATRIX_AXIS_DELETED, payload: MATRIX_AXIS_TYPE }
    | { type: MATRIX_ITEM_UPDATED, payload: MatrixItemUpdatePayload }
    | { type: MATRIX_ITEM_DELETED | MATRIX_ITEM_RESTORED, payload: MatrixItemPayload }
    | { type: MODIFY_BUNDLE; payload }
    | ProductActions


export function productReducer(state = initialProductState, action: action | ProductActions) {
    const handler = ProductStateHandler(state)
    switch (action.type) {
    case PRODUCT_ACTION_TYPES.SET:
        return handler.set(action.payload)
    case PRODUCT_ACTION_TYPES.PATCH:
        return handler.update(action.payload)
    case PRODUCT_ACTION_TYPES.CLEAR:
        return initialProductState

    case PRODUCT_LOADED:
        return handler.initialMatrixProvision(action.payload)
    case PRODUCT_CLEARED:
        return initialProductState
    case PRODUCT_UPDATED:
        return handler.updateProduct(action.payload)
    case MATRIX_AXIS_UPDATED:
        return handler.updateMatrixAxis(action.payload)
    case MATRIX_AXIS_DELETED:
        return handler.deleteMatrixAxis(action.payload)
    case MATRIX_ITEM_UPDATED:
        return handler.updateMatrixItem(action.payload)
    case MATRIX_ITEM_DELETED:
        return handler.deleteMatrixItem(action.payload)
    case MATRIX_ITEM_RESTORED:
        return handler.restoreMatrixItem(action.payload)
    case MODIFY_BUNDLE:
        return produce(state, draft => {
            draft.bundle.attributes = bundleReducer(state.bundle.attributes, action.payload)
        })
    case PRODUCT_ACTION_TYPES.SET_INVENTORY_DATA:
        return handler.setInventoryData(action.payload)
    default:
        return state
    }
}




// WEBPACK FOOTER //
// ./src/state/product/ProductReducer.ts